import { Mutation } from './Mutation'
import { Query } from './Query'

const resolvers = { Mutation, Query }

export const dashboardResolvers = resolvers
